import { useMutation } from "react-query";
import { bulkDownloadAttributes } from "components/attributes/lib/attribute-data";

export const useBulkDownloadAttributes = () => {
    return useMutation(({ searchValue }) => {
        return bulkDownloadAttributes(searchValue).then((data) => {
            JSONToCSVConvertor(data, "Attributes", true);
        });
    });
};

const JSONToCSVConvertor = (JSONData, ReportTitle, showLabel) => {
    const arrData = typeof JSONData !== "object" ? JSON.parse(JSONData) : JSONData;
    let CSV = "";

    if (showLabel) {
        let headerRow = "";

        for (const headerIndex in arrData[0]) {
            headerRow += headerIndex + ",";
        }

        headerRow = headerRow.slice(0, -1);
        CSV += headerRow + "\r\n";
    }

    for (let i = 0; i < arrData.length; i++) {
        let row = "";

        for (const index in arrData[i]) {
            row += '"' + arrData[i][index] + '",';
        }

        row.slice(0, row.length - 1);
        CSV += row + "\r\n";
    }

    if (CSV === "") {
        alert("Invalid data");

        return;
    }

    let fileName = "Report_";
    fileName += ReportTitle.replace(/ /g, "_");

    const link = document.createElement("a");
    link.href = `data:text/csv;charset=utf-8,${escape(CSV)}`;
    link.style = "visibility:hidden";
    link.download = fileName + ".csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
